
import { z } from "zod";

export const SowChangeHoldLevelValues = ["FULL", "REVENUE_ONLY", "NONE"] as const;
export const SowChangeHoldLevelSchema = /* @__PURE__ */ z.enum(SowChangeHoldLevelValues);
export const SowChangeHoldLevel: (typeof SowChangeHoldLevelSchema)["enum"] = { "FULL": "FULL", "REVENUE_ONLY": "REVENUE_ONLY", "NONE": "NONE" };
export type SowChangeHoldLevel = (typeof SowChangeHoldLevelValues)[number];
export const SowChangeHoldLevelDisplayNames = { "FULL": "Full hold",
"REVENUE_ONLY": "Revenue only",
"NONE": "No hold", } satisfies Record<SowChangeHoldLevel, string>;
